
import * as faker from 'faker';
import _ from 'lodash';
import { IItemListing } from './root.store';
import { waitForNoReason } from './util';
import { generateAddress, generateAmount, generateItemListing } from './util.generator';
import {
    CollectionPaymentSourceType,
    formatDate, ListProviderCollectionPaymentsRequest, ListProviderRefundRequestsRequest,
    ProviderCollectionPayment,
    ProviderCollectionRefundRequest
} from "@enter/core";
import {ClaimGenerator} from "./claim.generator";
import {PatientGenerator} from "./patient.generator";

export class OverpaymentGenerator {

    public collectionRefundRequests: ProviderCollectionRefundRequest[] = [];

    constructor(patientGenerator: PatientGenerator) {
        this.generateEntities(11);
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderCollectionRefundRequest());
    }

    public async loadOverpaymentListing(
        lprrr: ListProviderRefundRequestsRequest,
    ): Promise<IItemListing<ProviderCollectionRefundRequest> | undefined> {
        await waitForNoReason(400);
        return generateItemListing(lprrr, this.collectionRefundRequests);
    }

    private generateProviderCollectionRefundRequest(id: string = faker.random.uuid()): ProviderCollectionPayment {
        const refund = {
            id,
            created: formatDate('Date')(faker.date.past()),
            patient: {
                patientId: faker.random.uuid(),
                first: faker.name.firstName(),
                middle: _.sample([undefined, faker.name.firstName()]),
                last: faker.name.lastName(),
                suffix: _.sample([undefined, faker.name.suffix()]),
            }
        };
        this.collectionRefundRequests.push(refund);
        return refund;
    }
}